import "../pages/css/ProgressBar.css";
import { useTranslation } from "react-i18next";

const baseSteps = ["signUp", "address", "enrollmentKits", "review"];

const ProgressBar = ({ currentStep = 0, showAddOn = false }) => {
  const { t } = useTranslation();

  const steps = showAddOn
    ? ["signUp", "address", "enrollmentKits", "addOn", "review"]
    : baseSteps;

  const totalSteps = steps.length;
  const progressPercent = Math.min((currentStep / (totalSteps - 1)) * 100, 100);

  return (
    <div className="progress-bar stick-top-bar">
      <div className="top-bar">
        <div className="progress-steps">
          <div
            className="progress-line"
            style={{
              background: `linear-gradient(to right, #7700df, #ee7c2c ${progressPercent}%, #ffffff33 ${progressPercent}%)`,
              width: "100%",
            }}
          ></div>

          {steps.map((step, index) => (
            <span className={`circle ${index <= currentStep ? "active" : ""}`}>
              <span className="txt-span">{t(step)}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
